import React from 'react';
import PropTypes from 'prop-types';
import HiddenText from '../HiddenText';
import LivePulseValue from '../LivePulseValue';
import { getWeekStatusLabel, isLiveWeekStatus } from '../../utils/overviewUtils';
import '../Leaderboard/Leaderboard.css';
import '../LivePulse.css';
import styles from './MobileOverviewStatusChip.module.css';

const MobileOverviewStatusChip = ({ status, visibility, variant = 'default' }) => {
  const { shouldBlur, shouldShowOnlyPM, shouldBlurFutureWeek } = visibility;
  const statusKey = (status || 'none').toLowerCase();
  const label = getWeekStatusLabel(status);
  const live = isLiveWeekStatus(status);
  const isHero = variant === 'hero';
  const chipClass = isHero ? styles.chipHero : styles.chip;
  const className = `${chipClass} week-cell ${statusKey}${live ? ' live-status-pulse' : ''}`;

  if (shouldBlur) {
    return (
      <span className={isHero ? styles.blurHero : undefined}>
        <HiddenText
          text="NT"
          tooltip={
            shouldBlurFutureWeek
              ? 'Nice try! Future week lock hidden until you make your own lock for this week.'
              : 'Nice try! Lock status hidden until you make your pick.'
          }
          showTooltip
        />
      </span>
    );
  }

  if (shouldShowOnlyPM) {
    const pmLabel = status === 'pending' || status === 'pm' ? 'PM' : '-';
    return <span className={`${chipClass} week-cell none`}>{pmLabel}</span>;
  }

  const chip = <span className={className}>{label}</span>;

  if (live) {
    return (
      <LivePulseValue value={label} className={styles.chipWrap}>
        {chip}
      </LivePulseValue>
    );
  }

  return chip;
};

MobileOverviewStatusChip.propTypes = {
  status: PropTypes.string,
  visibility: PropTypes.shape({
    shouldBlur: PropTypes.bool,
    shouldShowOnlyPM: PropTypes.bool,
    shouldBlurFutureWeek: PropTypes.bool,
  }).isRequired,
  variant: PropTypes.oneOf(['default', 'hero']),
};

export default MobileOverviewStatusChip;
